<script setup>
import { useRoute } from "vue-router";
import { watch } from "vue";
import common from "@/common/global";
import pubResApi from "@/api/api";
const route = useRoute();
console.log(pubResApi.getCount())
watch(() => route.meta.title, (newTitle) => {
  common.wxSetTitle(newTitle);
});
</script>
<template id="app">
  <router-view></router-view>
</template>
<style lang="scss"> 
@import './assets/css/public.scss';
@import './assets/css/Base/flex.scss';
#app{
  height: 100%;
  width: 100%;
}
body{
  margin: 0 auto;
  padding: 0 auto;
}
</style>